export enum Role {
	root = "root",
	admin = "Admin",
	manager = "Менеджер",
}
